import { render, staticRenderFns } from "./lineamientos.vue?vue&type=template&id=687240f1&scoped=true"
import script from "./lineamientos.vue?vue&type=script&lang=js"
export * from "./lineamientos.vue?vue&type=script&lang=js"
import style0 from "./lineamientos.vue?vue&type=style&index=0&id=687240f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687240f1",
  null
  
)

export default component.exports